import { createBrowserRouter, Navigate } from 'react-router';

import { SignInPage } from '@/features/auth/SignInPage';
import { SupportHandoffPage } from '@/features/auth/SupportHandoffPage';
import { CostCodesPage } from '@/features/cost-codes/CostCodesPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { EntriesTab } from '@/features/entries/EntriesTab';
import { EntryPage } from '@/features/entries/EntryPage';
import { HistoryPage } from '@/features/entries/HistoryPage';
import { EquipmentPage } from '@/features/equipment/EquipmentPage';
import { JobDetailPage } from '@/features/jobs/JobDetailPage';
import { JobSettingsTab } from '@/features/jobs/JobSettingsTab';
import { JobsPage } from '@/features/jobs/JobsPage';
import { ToDateTab } from '@/features/jobs/ToDateTab';
import { PeoplePage } from '@/features/people/PeoplePage';
import { QuickBooksPage } from '@/features/quickbooks/QuickBooksPage';
import { RollupPage } from '@/features/rollup/RollupPage';
import { SettingsPage } from '@/features/settings/SettingsPage';

import { AppShell } from './AppShell';
import { AuthGuard, OfficeOnly } from './AuthGuard';
import { ErrorPage, NotFoundPage } from './ErrorPage';

export const router = createBrowserRouter([
  { path: '/sign-in', element: <SignInPage />, errorElement: <ErrorPage /> },
  // Landing page of a Fuorix support "Open read-only" link (doc 13 "Support panel").
  { path: '/support-handoff', element: <SupportHandoffPage />, errorElement: <ErrorPage /> },
  {
    element: <AuthGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: '/entries/:id', element: <EntryPage /> },
          { path: '/history', element: <HistoryPage /> },
          {
            element: <OfficeOnly />,
            children: [
              { path: '/', element: <DashboardPage /> },
              { path: '/jobs', element: <JobsPage /> },
              {
                path: '/jobs/:id',
                element: <JobDetailPage />,
                children: [
                  { index: true, element: <ToDateTab /> },
                  { path: 'entries', element: <EntriesTab /> },
                  { path: 'cost-codes', element: <CostCodesPage /> },
                  { path: 'settings', element: <JobSettingsTab /> },
                ],
              },
              { path: '/people', element: <PeoplePage /> },
              { path: '/equipment', element: <EquipmentPage /> },
              { path: '/rollup', element: <RollupPage /> },
              { path: '/quickbooks', element: <QuickBooksPage /> },
              // Registered as the Intuit Reconnect / Disconnect URL and used in the owner email (Q-0 5/5).
              { path: '/settings/quickbooks', element: <Navigate to="/quickbooks" replace /> },
              { path: '/settings', element: <SettingsPage /> },
              { path: '/dashboard', element: <Navigate to="/" replace /> },
            ],
          },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
